import React from "react";

const FeatureContent = [
  {
    icon: "22",
    meta: "Aule e docenti",
    subTitle: `Organizza le aule, i docenti e i corsisti per proporre la tua offerta formativa nel modo migliore.`,
    dataDelay: "0",
  },
  {
    icon: "21",
    meta: "Anagrafiche e pagamenti",
    subTitle: `Gestisci le anagrafiche dei corsi controllando lo stato delle iscrizioni e dei pagamenti.`,
    dataDelay: "100",
  },
  {
    icon: "20",
    meta: "Fatturazione integrata",
    subTitle: `Tieni traccia della fatturazione integrata con lo SDI.`,
    dataDelay: "300",
  },
];

const FeatureFour = () => {
  return (
    <div className="row justify-content-center">
      {FeatureContent.map((val, i) => (
        <div
          className="col-lg-4 col-md-6"
          key={i}
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay={val.dataDelay}
        >
          <div className="block-style-five">
            <div className="icon">
              <img src={`images/icon/${val.icon}.svg`} alt="icon" />
            </div>
            <h6 className="title">
              <span>{val.meta}</span>
            </h6>
            <p>{val.subTitle}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeatureFour;
